const ENV_CONFIG = {
  dev: {
    baseUrl: 'https://d2u1wndd7r3e2j.cloudfront.net',
    token: 'IfyijFiefsEfdoghyodgashtiaka',
  },
  qa: {
    baseUrl: 'https://healthcheckapps.qa.sondeservices.com',
    token: 'OrUsUlghamtEnhuesVutsAjBiar!',
  },
  prod: {
    baseUrl: 'https://healthcheckapps.prod.sondeservices.com',
    token: 'eatomVaknocdidridcokFeshitWi',
  },
};

export default ENV_CONFIG;